var _circle, _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoMasterTounament(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.092,
    height: 200.518,
    viewBox: "0 0 200.092 200.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_170406",
    "data-name": "Group 170406",
    transform: "translate(-8242 17634)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_412",
    "data-name": "Ellipse 412",
    cx: 100.046,
    cy: 100.046,
    r: 100.046,
    transform: "translate(8242 -17633.574)",
    fill: "rgba(1,171,193,0.05)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shrug-cuate",
    transform: "translate(8261.25 -17634)",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1",
    transform: "translate(0 3.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170353",
    "data-name": "Group 170353"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151016",
    "data-name": "Rectangle 151016",
    width: 14.594,
    height: 4.645,
    transform: "translate(154.118 154.878) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41491",
    "data-name": "Path 41491",
    d: "M410.04,424.832c2.424-.042,8.638-.145,10.978-.17l3.615-.017-.191.191-.017-4.645.207.208c-2.424-.008-8.6-.029-10.945-.062l-3.648-.046.1-.1-.1,4.645h0Zm0,0-.1-4.645v-.1h.1c1.822-.025,5.475-.066,7.3-.083l7.3-.029h.208v.208l-.021,4.645v.191h-.191l-3.682-.017c-2.324-.025-8.513-.129-10.912-.17h0Z",
    transform: "translate(-262.376 -264.102)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41492",
    "data-name": "Path 41492",
    d: "M277.3,230.732c2.424-.042,8.638-.145,10.979-.17l3.615-.017-.191.191-.017-4.645.208.208c-2.424-.008-8.6-.029-10.945-.062l-3.648-.046.1-.1-.1,4.645h0Zm0,0-.1-4.645v-.1h.1c1.822-.025,5.475-.066,7.3-.083l7.3-.029h.207v.208l-.021,4.645v.191h-.191l-3.682-.017c-2.324-.025-8.513-.129-10.912-.17h0Z",
    transform: "translate(-184.731 -150.566)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41493",
    "data-name": "Path 41493",
    d: "M296.91,244.842c2.424-.042,8.638-.145,10.979-.17l3.615-.017-.191.191L311.3,240.2l.208.208c-2.424-.008-8.6-.029-10.945-.062l-3.648-.046.1-.1-.1,4.645h0Zm0,0-.1-4.645v-.1h.1c1.822-.025,5.475-.066,7.3-.083l7.3-.029h.208v.208l-.021,4.645v.191H311.5l-3.682-.017c-2.324-.025-8.513-.129-10.912-.17h0Z",
    transform: "translate(-196.202 -158.82)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151017",
    "data-name": "Rectangle 151017",
    width: 14.594,
    height: 4.645,
    transform: "translate(123.408 80.166) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151018",
    "data-name": "Rectangle 151018",
    width: 14.594,
    height: 4.645,
    transform: "translate(14.693 160.734) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151019",
    "data-name": "Rectangle 151019",
    width: 14.594,
    height: 4.645,
    transform: "translate(22.833 4.856) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41494",
    "data-name": "Path 41494",
    d: "M54.52,63.392c2.424-.042,8.638-.145,10.979-.17l3.615-.017-.191.191-.017-4.645.208.208c-2.424-.008-8.6-.029-10.945-.062l-3.648-.046.1-.1-.1,4.645h0Zm0,0-.1-4.645v-.1h.1c1.822-.025,5.475-.066,7.3-.083l7.3-.029h.208v.208L69.3,63.392v.191h-.191l-3.682-.017c-2.324-.025-8.513-.129-10.912-.17h0Z",
    transform: "translate(-54.42 -52.683)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41495",
    "data-name": "Path 41495",
    d: "M390.43,49.282c2.424-.042,8.638-.145,10.979-.17l3.615-.017-.191.191-.017-4.645.208.208-7.3-.029c-1.818-.012-5.479-.058-7.3-.079l.1-.1-.1,4.645h0Zm0,0-.1-4.645v-.1h.1c1.822-.025,5.475-.066,7.3-.083l7.3-.029h.207v.208l-.021,4.645v.191h-.191l-3.682-.017c-2.324-.025-8.513-.129-10.912-.17h0Z",
    transform: "translate(-250.905 -44.43)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170357",
    "data-name": "Group 170357",
    transform: "translate(17.271 17.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170354",
    "data-name": "Group 170354"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151020",
    "data-name": "Rectangle 151020",
    width: 33.608,
    height: 40.764,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151021",
    "data-name": "Rectangle 151021",
    width: 25.925,
    height: 33.326,
    transform: "translate(3.839 3.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151022",
    "data-name": "Rectangle 151022",
    width: 1.013,
    height: 33.326,
    transform: "translate(3.839 3.723)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151023",
    "data-name": "Rectangle 151023",
    width: 1.013,
    height: 40.764,
    transform: "translate(33.604)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151024",
    "data-name": "Rectangle 151024",
    width: 6.114,
    height: 18.213,
    transform: "translate(12.527 8.318)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151025",
    "data-name": "Rectangle 151025",
    width: 16.3,
    height: 8.924,
    transform: "translate(9.862 20.716)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170355",
    "data-name": "Group 170355",
    transform: "translate(93.199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151026",
    "data-name": "Rectangle 151026",
    width: 33.608,
    height: 40.764,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151027",
    "data-name": "Rectangle 151027",
    width: 25.925,
    height: 33.326,
    transform: "translate(3.839 3.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151028",
    "data-name": "Rectangle 151028",
    width: 1.013,
    height: 33.326,
    transform: "translate(3.839 3.723)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151029",
    "data-name": "Rectangle 151029",
    width: 1.013,
    height: 40.764,
    transform: "translate(33.608)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151030",
    "data-name": "Rectangle 151030",
    width: 6.114,
    height: 18.213,
    transform: "translate(12.527 8.318)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151031",
    "data-name": "Rectangle 151031",
    width: 16.3,
    height: 8.924,
    transform: "translate(9.862 20.716)",
    fill: "none",
    stroke: "#ebebeb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170356",
    "data-name": "Group 170356",
    transform: "translate(46.6 9.808)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151032",
    "data-name": "Rectangle 151032",
    width: 33.608,
    height: 40.764,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151033",
    "data-name": "Rectangle 151033",
    width: 25.925,
    height: 33.326,
    transform: "translate(3.839 3.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151034",
    "data-name": "Rectangle 151034",
    width: 1.013,
    height: 33.326,
    transform: "translate(3.839 3.723)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151035",
    "data-name": "Rectangle 151035",
    width: 1.013,
    height: 40.764,
    transform: "translate(33.608)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151036",
    "data-name": "Rectangle 151036",
    width: 5.238,
    height: 13.241,
    transform: "translate(14.291 12.336)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151037",
    "data-name": "Rectangle 151037",
    width: 14.071,
    height: 9.127,
    transform: "translate(10.974 20.384)",
    fill: "none",
    stroke: "#dbdbdb",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170358",
    "data-name": "Group 170358",
    transform: "translate(3.587 91.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41496",
    "data-name": "Path 41496",
    d: "M357.626,328.011l-2.482,5.28A4.291,4.291,0,0,1,349.3,335.4a4.4,4.4,0,0,1-2.108-5.853l3.972-8.447c.037-.083.12-.046.158-.125a.262.262,0,0,1,0-.2,4.527,4.527,0,0,1,5.852-2.109,10.053,10.053,0,1,0,8.555-18.192,9.915,9.915,0,0,0-9.9.8,4.429,4.429,0,0,1-6.209-1.133,4.377,4.377,0,0,1,1.179-6.093,18.861,18.861,0,1,1,6.844,33.957ZM349.262,345.8l-.689,1.461a4.3,4.3,0,0,1-5.848,2.109,4.4,4.4,0,0,1-2.109-5.848l.689-1.461a4.467,4.467,0,0,1,5.852-2.109,4.351,4.351,0,0,1,2.109,5.852Z",
    transform: "translate(-225.166 -280.191)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41497",
    "data-name": "Path 41497",
    d: "M72.185,290.937l-2.391-5.321A4.291,4.291,0,0,1,72,279.805a4.406,4.406,0,0,1,5.815,2.212l3.823,8.513c.037.083-.046.12-.008.2a.245.245,0,0,1,.154.129,4.524,4.524,0,0,1-2.212,5.811A10.053,10.053,0,1,0,87.8,315.011a9.921,9.921,0,0,0,5.84-8.031,4.43,4.43,0,0,1,4.906-3.972,4.378,4.378,0,0,1,3.856,4.86,18.86,18.86,0,1,1-30.221-16.926Zm-8.048-17.931-.66-1.474a4.291,4.291,0,0,1,2.212-5.811A4.4,4.4,0,0,1,71.5,267.93l.66,1.473a4.467,4.467,0,0,1-2.212,5.815A4.345,4.345,0,0,1,64.136,273.006Z",
    transform: "translate(-63.062 -265.34)",
    fill: "#ebebeb"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1",
    transform: "translate(7.463 123.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170370",
    "data-name": "Group 170370",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170367",
    "data-name": "Group 170367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170360",
    "data-name": "Group 170360",
    transform: "translate(14.958 13.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41498",
    "data-name": "Path 41498",
    d: "M120.8,367.105c-5.379,7.284-10.991,15.743-12.357,24.879a.122.122,0,0,0,.237.046,54.364,54.364,0,0,1,2.378-7.318c3.536-.971,7.006-1.772,8.866-5.284,1.893-3.607,1.652-8.314,1.295-12.244-.025-.212-.311-.22-.419-.083Z",
    transform: "translate(-108.438 -367.009)",
    fill: "#01abc1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170359",
    "data-name": "Group 170359",
    transform: "translate(2.663 2.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41499",
    "data-name": "Path 41499",
    d: "M114.86,387.884a60.177,60.177,0,0,1,9.463-15.328c.025-.029.066.012.042.041a64.632,64.632,0,0,0-6.458,10.157c1.781-1.81,3.731-3.428,5.421-5.346.033-.037.087.017.054.054a29.849,29.849,0,0,1-5.686,5.682q-.878,1.619-1.776,3.246c.145-.083.3-.154.448-.228.025-.012.05.025.025.042-.166.083-.332.174-.5.245-.282.511-.564,1.025-.855,1.536-.066.112-.224.012-.17-.1Z",
    transform: "translate(-114.853 -372.546)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41500",
    "data-name": "Path 41500",
    d: "M119.159,401.044a31.909,31.909,0,0,0,4.13-2.756c.033-.029.087.021.05.05a21.562,21.562,0,0,1-4.122,2.806C119.15,401.176,119.092,401.081,119.159,401.044Z",
    transform: "translate(-117.355 -387.598)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170362",
    "data-name": "Group 170362",
    transform: "translate(13.948)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41501",
    "data-name": "Path 41501",
    d: "M106.392,371.071c.012.112.2.108.2-.008.029-3.009,0-6.031.05-9.053.772-1.557,2.424-2.416,3.578-3.665a15.955,15.955,0,0,0,2.146-2.988,21.483,21.483,0,0,0,2.49-8.3c.32-3.217-.9-13.838-2.262-13.469-.706.191-2.98,5.45-3.586,7.189a50.292,50.292,0,0,0-2.142,8.816,94.091,94.091,0,0,0-.469,21.476Z",
    transform: "translate(-106.004 -333.577)",
    fill: "#01abc1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170361",
    "data-name": "Group 170361",
    transform: "translate(0.34 1.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41502",
    "data-name": "Path 41502",
    d: "M106.851,360.7l.012-.012a67.87,67.87,0,0,1,1.826-11.344,37.995,37.995,0,0,1,3.922-11.273.058.058,0,0,1,.1.058,41.55,41.55,0,0,0-3.15,8.65c.137-.216.3-.419.444-.618.058-.079.187,0,.133.079a5.744,5.744,0,0,1-.639.9c-.008.008-.017.008-.025.012-.706,2.843-1.212,5.753-1.644,8.654.033-.037.062-.075.1-.112s.058.008.046.033q-.081.143-.174.286c-.22,1.473-.419,2.943-.623,4.4a20.683,20.683,0,0,0,6.122-8.135c0-.017.029-.008.025.008a16.932,16.932,0,0,1-6.189,8.426c-.054.394-.108.784-.166,1.175-.012.083-.141.058-.141-.021,0-.349.017-.693.033-1.042a.078.078,0,0,1-.008-.125Z",
    transform: "translate(-106.823 -338.039)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41503",
    "data-name": "Path 41503",
    d: "M109.851,366.346a60.3,60.3,0,0,0,5.342-9.2c.017-.037.079-.012.066.029a29.993,29.993,0,0,1-5.3,9.252c-.046.054-.141-.017-.1-.079Z",
    transform: "translate(-108.591 -349.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41504",
    "data-name": "Path 41504",
    d: "M116.266,349.18c.83-1.469,1.706-2.9,2.486-4.4.021-.042.079,0,.062.037a22.943,22.943,0,0,1-2.42,4.433C116.34,349.329,116.22,349.263,116.266,349.18Z",
    transform: "translate(-112.341 -341.974)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41505",
    "data-name": "Path 41505",
    d: "M115.482,356.94s.017.025,0,.025A.012.012,0,1,1,115.482,356.94Z",
    transform: "translate(-111.881 -349.095)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170364",
    "data-name": "Group 170364",
    transform: "translate(3.892 4.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41506",
    "data-name": "Path 41506",
    d: "M90.183,368.771a30.545,30.545,0,0,1-.7,5.927c.029.216.062.428.091.647a28.143,28.143,0,0,0,1.058-6.608.2.2,0,0,0,.008-.2v-.008a43.794,43.794,0,0,0-.664-8.953c-.93-5.529-2.968-10.837-6.824-14.98a.277.277,0,0,0-.428.087c-1.557,3.956-1.013,8.679.311,12.626a23.184,23.184,0,0,0,3.059,6c1.324,1.859,3.009,3.433,4.084,5.466Z",
    transform: "translate(-81.776 -344.525)",
    fill: "#01abc1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170363",
    "data-name": "Group 170363",
    transform: "translate(1.687 1.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41507",
    "data-name": "Path 41507",
    d: "M85.99,349.089A42.519,42.519,0,0,1,92.5,369.062c0,.125-.2.158-.22.029-.087-.631-.183-1.253-.282-1.876h-.008a23.989,23.989,0,0,1-4.147-4.786.034.034,0,0,1,.054-.042,50.375,50.375,0,0,0,4.03,4.383q-.392-2.322-.938-4.578c-.1-.112-.2-.228-.291-.34-.062-.075.042-.183.108-.108.029.033.058.066.087.1a53.3,53.3,0,0,0-1.909-6.068,18.19,18.19,0,0,1-2.648-3.408.029.029,0,0,1,.05-.029,27.774,27.774,0,0,0,1.689,2.241c.245.282.515.548.772.822a46.6,46.6,0,0,0-2.993-6.238c-.054-.091.087-.17.141-.083Z",
    transform: "translate(-85.841 -349.039)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41508",
    "data-name": "Path 41508",
    d: "M87.863,366.762c1.183,1.59,2.528,3.109,3.628,4.748.033.046-.037.1-.075.058a24.146,24.146,0,0,1-3.628-4.761c-.033-.05.046-.091.079-.046Z",
    transform: "translate(-86.976 -359.394)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41509",
    "data-name": "Path 41509",
    d: "M97.019,379.105l.05.05c.033.033-.021.091-.054.054l-.05-.05C96.932,379.126,96.986,379.072,97.019,379.105Z",
    transform: "translate(-92.342 -366.62)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170366",
    "data-name": "Group 170366",
    transform: "translate(0 17.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41510",
    "data-name": "Path 41510",
    d: "M72.4,376.126a18.23,18.23,0,0,0,3.856,9.048,9.6,9.6,0,0,0,3.13,2.441c1.353.668,2.773,1.44,4.176,1.992a27.219,27.219,0,0,1,1.478,5.251c.046-.154.091-.311.137-.465-.9-7.729-5.9-14.332-12.294-18.57a.31.31,0,0,0-.477.3Z",
    transform: "translate(-72.4 -375.769)",
    fill: "#01abc1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170365",
    "data-name": "Group 170365",
    transform: "translate(2.192 2.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41511",
    "data-name": "Path 41511",
    d: "M77.7,382c-.046-.042.017-.12.066-.083a26.145,26.145,0,0,1,8.148,10.045c.046.1-.1.2-.158.091-.3-.519-.6-1.029-.909-1.523h0a8.777,8.777,0,0,1-3.927-2.279c-.029-.025.012-.071.042-.041a9.093,9.093,0,0,0,1.847,1.3,19.817,19.817,0,0,0,1.855.735c-.54-.859-1.1-1.681-1.693-2.482a17.035,17.035,0,0,1-4.387-2.466c-.042-.029,0-.1.042-.071a43.748,43.748,0,0,0,4.076,2.179,36.544,36.544,0,0,0-2.881-3.358c-.5-.262-1-.527-1.482-.805-.037-.025-.012-.091.033-.075a5.537,5.537,0,0,1,1.137.556c-.577-.585-1.17-1.158-1.81-1.723Z",
    transform: "translate(-77.682 -381.906)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41512",
    "data-name": "Path 41512",
    d: "M77.965,388.55a2.6,2.6,0,0,1,.245.174c.025.021-.008.05-.029.042a1.957,1.957,0,0,1-.257-.145C77.878,388.592,77.923,388.521,77.965,388.55Z",
    transform: "translate(-77.812 -385.789)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170369",
    "data-name": "Group 170369",
    transform: "translate(5.23 31.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170368",
    "data-name": "Group 170368",
    transform: "translate(0 2.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41513",
    "data-name": "Path 41513",
    d: "M102.524,434.619H85l1.411-15.959.311-3.52H100.8l.311,3.52Z",
    transform: "translate(-85 -415.14)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41514",
    "data-name": "Path 41514",
    d: "M103.244,418.66,88.65,417.5l.208-2.362h14.075Z",
    transform: "translate(-87.135 -415.14)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151038",
    "data-name": "Rectangle 151038",
    width: 15.752,
    height: 3.482,
    transform: "translate(0.884)",
    fill: "#455a64"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1",
    transform: "translate(4.496 15.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170405",
    "data-name": "Group 170405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170374",
    "data-name": "Group 170374",
    transform: "translate(40.386 116.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41515",
    "data-name": "Path 41515",
    d: "M267.472,398.353h-39.78c-1.727-6.79-4.391-17.242-6.712-26.344a.025.025,0,0,0,0-.017c-.141-.56-.282-1.112-.419-1.656-.087-.34-.174-.677-.257-1-2.229-8.75-3.993-15.673-4.034-15.831-.025-.1-.046-.174-.062-.232-.025-.083-.033-.129-.033-.129h38.406l12.892,45.221Z",
    transform: "translate(-193.915 -353.115)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170373",
    "data-name": "Group 170373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170371",
    "data-name": "Group 170371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41516",
    "data-name": "Path 41516",
    d: "M221.976,353.08v.017c0,.025,0,.071,0,.129q0,.679-.012,1.357c-.017,1.15-.071,2.3-.145,3.449a107.242,107.242,0,0,1-1.76,13.394,141.631,141.631,0,0,1-4.458,17.238c-.162.49-.261.764-.27.793,0,0-1.332.66-3.063,1.515-.079.042-.162.083-.245.125-1.992.988-4.458,2.212-6.064,3.013-.851.423-1.465.73-1.64.826-.025.008-.042.017-.046.025s-.071,1.366-.154,3.362H162.634c.83-7.035.942-7.965.942-7.965a28.185,28.185,0,0,1-.942-8.92c.851-8.932,6.334-26.871,6.828-27.942.116-.262.187-.394.187-.394h10.493L205,353.088h16.98Z",
    transform: "translate(-162.552 -353.08)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41517",
    "data-name": "Path 41517",
    d: "M262.5,453.286v.091c.012,1.129-.033,2.258-.046,3.387h-.419c.091-1.133.166-2.275.3-3.4.008-.1.017-.2.033-.3a.062.062,0,0,1,.125,0C262.5,453.136,262.5,453.211,262.5,453.286Z",
    transform: "translate(-220.746 -411.526)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170372",
    "data-name": "Group 170372",
    transform: "translate(4.732 1.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41518",
    "data-name": "Path 41518",
    d: "M251.137,443.815c1.764-1.224,3.665-2.25,5.533-3.3,1.909-1.079,3.848-2.113,5.836-3.038a94.716,94.716,0,0,1,12.066-4.379c.1-.033.174.137.071.178-3.935,1.689-7.749,3.628-11.663,5.363-1.967.872-3.951,1.71-5.923,2.578s-3.893,1.851-5.877,2.681c-.054.021-.091-.046-.042-.075Z",
    transform: "translate(-219.087 -401.113)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41519",
    "data-name": "Path 41519",
    d: "M277.107,384.547c.05-1.93.187-3.856.282-5.786.224-4.549.4-9.127.826-13.664a.141.141,0,0,1,.282.008c.058,3.52-.079,7.052-.149,10.572-.037,1.76-.087,3.524-.137,5.284a49.953,49.953,0,0,0-.033,5.047c.1,1.27.374,3.736,2.03,3.889,1.561.145,2.416-1.54,2.806-2.773a48.339,48.339,0,0,0,1.66-9.775c.191-1.93.382-3.856.5-5.79.116-1.955.27-4.836.162-6.786-.008-.125.174-.116.2,0a46.214,46.214,0,0,1,.278,7.069c-.378,17.956-3.213,18.981-4.707,19.272a3.253,3.253,0,0,1-.556.058c-.017.407-.075.818-.1,1.224-.046.639-.124,1.27-.207,1.905a14,14,0,0,1-.39,1.843,6.823,6.823,0,0,1-.648,1.764.1.1,0,0,1-.178-.054,8.632,8.632,0,0,1,.154-1.818c.083-.618.17-1.245.3-1.859s.237-1.208.361-1.81c.083-.4.141-.822.216-1.229a2.957,2.957,0,0,1-2.212-1.739,10.771,10.771,0,0,1-.718-4.848Z",
    transform: "translate(-234.29 -361.1)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41520",
    "data-name": "Path 41520",
    d: "M189.518,382.059a39.689,39.689,0,0,0,7.5.2,13.088,13.088,0,0,0,6.525-2.557c4.134-3.2,5.944-8.451,7.064-13.373a.088.088,0,0,1,.174.025c-.469,4.267-1.386,8.679-4.142,12.116a13.3,13.3,0,0,1-4.4,3.623,12.9,12.9,0,0,1-5.811,1.2,28.145,28.145,0,0,1-6.957-.938.147.147,0,0,1,.042-.291Z",
    transform: "translate(-182.961 -362.019)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41521",
    "data-name": "Path 41521",
    d: "M312.8,378.713a3.759,3.759,0,0,1-2.088-.535,6.246,6.246,0,0,1-1.864-2.964c-1.208-3.329-1.8-8.3-2.192-12.9-.008-.1-.054-.1-.05.008a64.89,64.89,0,0,0,1.357,11.472,17.224,17.224,0,0,0,1.287,3.731,3.072,3.072,0,0,0,1.644,1.652,2.414,2.414,0,0,0,1.926-.191c.05-.025.037-.262-.017-.27Z",
    transform: "translate(-251.548 -359.67)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41522",
    "data-name": "Path 41522",
    d: "M180.065,356.058c-1.345,7.376-2.943,14.859-4.416,22.214-.374,2.2-1.034,4.375-.9,6.612a45.948,45.948,0,0,0,1.067,6.707c-.237,1.42-.469,2.843-.722,4.259s-.486,2.806-.76,4.2c.129-1.419.291-2.835.444-4.25s.32-2.831.486-4.246A36.9,36.9,0,0,1,174,384.934a9.817,9.817,0,0,1,.054-2.341c.448-3.018,1.079-5.969,1.71-8.928,1.287-5.906,2.7-11.784,4.3-17.615h0Z",
    transform: "translate(-173.953 -356.05)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170376",
    "data-name": "Group 170376",
    transform: "translate(78.264 56.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41523",
    "data-name": "Path 41523",
    d: "M264.74,214.955c17.341,15.706,29.673,29.241,29.507,35.393-.369,13.789-7.637,16.764-8.932,16.325-13.676-4.641-22.368-30.673-28.117-46.4C251.491,204.657,259.772,210.456,264.74,214.955Z",
    transform: "translate(-254.662 -209.123)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170375",
    "data-name": "Group 170375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41524",
    "data-name": "Path 41524",
    d: "M288.5,236l-21.849,11.667s-8.9-19.417-11.929-31.026,1.623-11.236,11.8-2.15S288.5,236,288.5,236Z",
    transform: "translate(-253.809 -207.788)",
    fill: "#01abc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41525",
    "data-name": "Path 41525",
    d: "M261.746,226a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,261.746,226Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm13.934-.739a1.044,1.044,0,1,1-1.341-1.291c-.054-.058-.112-.112-.17-.166a1.259,1.259,0,1,0,1.677,1.623l-.166-.166Zm-20.4-11.875a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,255.283,215.69Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm19.392,28.81a1.254,1.254,0,0,0-1.1,1.855l.187-.1a1.071,1.071,0,0,1-.124-.5,1.043,1.043,0,0,1,1.038-1.038,1.056,1.056,0,0,1,.93.556l.191-.1A1.269,1.269,0,0,0,274.675,246.8Zm-6.467-10.31a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,268.209,236.493Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.929-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,281.138,236.493Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Z",
    transform: "translate(-253.938 -212.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41526",
    "data-name": "Path 41526",
    d: "M300.832,267.433A170.08,170.08,0,0,1,282.6,277.6c-.079.046-.141-.087-.058-.125,1.652-.826,10.626-6.317,18.221-10.182C300.853,267.251,300.911,267.379,300.832,267.433Z",
    transform: "translate(-270.594 -242.591)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41527",
    "data-name": "Path 41527",
    d: "M283.728,239.829l-17.068,8.866s-8.9-19.417-11.933-31.03c-1.112-4.279-1.187-6.927-.324-8.115l29.329,30.279Z",
    transform: "translate(-253.814 -208.819)",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170378",
    "data-name": "Group 170378",
    transform: "translate(46.702 54.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41528",
    "data-name": "Path 41528",
    d: "M232.721,266.683l-2.843-17.869s5.574-7,1.918-14.677c-1.847-3.885-11.186-22.991-17.9-27.747-5.512-3.906-14.868-1.8-17.985,3.594-7.056,12.2-14.067,26.539-18.143,56.715Z",
    transform: "translate(-177.77 -204.382)",
    fill: "#01abc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41529",
    "data-name": "Path 41529",
    d: "M191.928,226a1.21,1.21,0,0,0-.477.1,1.258,1.258,0,0,0-.776,1.158,1.093,1.093,0,0,0,.054.349h0a1.257,1.257,0,1,0,1.2-1.6Zm0,2.3a1.045,1.045,0,0,1-1.038-1.046h0a1.027,1.027,0,0,1,.382-.8l0,0a1,1,0,0,1,.652-.237,1.046,1.046,0,0,1,1.05,1.038A1.057,1.057,0,0,1,191.928,228.3Zm12.929-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,204.857,226Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.925-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,217.782,226Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088ZM198.395,215.69a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,198.395,215.69Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.925-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,211.32,215.69Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088ZM191.928,246.8a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,191.928,246.8Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.929-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,204.857,246.8Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.925-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,217.782,246.8Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.929-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,230.712,246.8Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm-44.039-11.734c-.054.145-.108.295-.162.444h0a1.026,1.026,0,0,1-.187.535h0c-.054.154-.1.3-.158.452a1.268,1.268,0,0,0,.569-1.058,1.254,1.254,0,0,0-.058-.374Zm11.721-.88a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,198.395,236.493Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.925-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,211.32,236.493Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.925-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,224.245,236.493Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm-45,28.831c-.008.071-.021.141-.033.216A1.043,1.043,0,0,1,179,269.91a.9.9,0,0,1-.1,0h0c-.008.071-.021.141-.029.212.046,0,.091.008.137.008a1.26,1.26,0,0,0,.241-2.5Zm12.684-.021a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,191.928,267.607Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.929-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,204.857,267.607Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.925-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,217.782,267.607Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.929-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,230.712,267.607Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088ZM185.465,257.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,185.465,257.3Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.929-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,198.395,257.3Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.925-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,211.32,257.3Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.925-2.3a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,224.245,257.3Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Z",
    transform: "translate(-178.413 -210.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170377",
    "data-name": "Group 170377",
    transform: "translate(26.064 39.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41530",
    "data-name": "Path 41530",
    d: "M257.352,300.58a57.971,57.971,0,0,0-8.463,1.565c-1.378.382-2.727.826-4.072,1.3-.672.237-1.345.448-2.026.66a9.139,9.139,0,0,1-2.179.457c-.066,0-.062.1,0,.1a16.276,16.276,0,0,0,2.109-.079,15.567,15.567,0,0,0,2-.419c1.4-.374,2.781-.814,4.176-1.2,2.814-.784,5.628-1.565,8.5-2.146.133-.025.1-.253-.042-.237Z",
    transform: "translate(-240.564 -300.58)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41531",
    "data-name": "Path 41531",
    d: "M278.146,306.021a63.36,63.36,0,0,0-7.1-.2c-1.187.037-2.362.145-3.536.282-.564.066-1.125.141-1.685.224-.618.091-1.22.266-1.839.349-.062.008-.062.108,0,.1.585-.058,1.183-.025,1.768-.05s1.179-.058,1.768-.083c1.183-.054,2.362-.091,3.545-.154,2.362-.129,4.719-.228,7.085-.274.129,0,.116-.183-.008-.2Z",
    transform: "translate(-254.236 -303.63)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170380",
    "data-name": "Group 170380",
    transform: "translate(34.421 55.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41532",
    "data-name": "Path 41532",
    d: "M176.023,214.438c-16.59,16.495-28.279,29.76-27.83,35.9,1.009,13.755,8.808,16.13,10.082,15.631,13.444-5.271,20.517-30.59,25.531-46.57,4.977-15.86-3.03-9.684-7.778-4.96Z",
    transform: "translate(-148.18 -208.241)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170379",
    "data-name": "Group 170379",
    transform: "translate(4.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41533",
    "data-name": "Path 41533",
    d: "M158.53,235.767,180.9,246.405s7.986-18.981,10.472-30.719-2.146-11.149-11.883-1.6S158.53,235.767,158.53,235.767Z",
    transform: "translate(-158.53 -206.899)",
    fill: "#01abc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41534",
    "data-name": "Path 41534",
    d: "M182.575,226a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,182.575,226Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm6.467-12.614a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,189.042,215.69Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm-6.467,28.81a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,182.575,246.8Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm-18.184-11.751c-.058.062-.116.125-.174.183a1.137,1.137,0,0,1,.021.208,1.049,1.049,0,0,1-1.05,1.05c-.046,0-.091,0-.137-.008-.062.062-.116.125-.17.183a1.076,1.076,0,0,0,.307.041,1.266,1.266,0,0,0,1.266-1.266,1.219,1.219,0,0,0-.062-.39Zm11.721-.863a1.26,1.26,0,0,0,0,2.519,1.276,1.276,0,0,0,1.266-1.266A1.255,1.255,0,0,0,176.112,236.493Zm0,2.3a1.046,1.046,0,0,1-1.038-1.05,1.035,1.035,0,0,1,1.038-1.038,1.044,1.044,0,1,1,0,2.088Zm12.929-2.3a1.258,1.258,0,0,0-1.253,1.254,1.278,1.278,0,0,0,.606,1.083c.025-.066.05-.137.075-.208a1.062,1.062,0,0,1-.465-.876,1.043,1.043,0,0,1,1.038-1.038,1.012,1.012,0,0,1,.112,0c.025-.066.046-.133.071-.2A.877.877,0,0,0,189.042,236.493Z",
    transform: "translate(-161.074 -212.041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41535",
    "data-name": "Path 41535",
    d: "M168.81,267.63a170.654,170.654,0,0,0,18.682,9.31c.079.042.137-.091.054-.129-1.689-.747-10.908-5.815-18.678-9.322C168.777,267.447,168.727,267.58,168.81,267.63Z",
    transform: "translate(-164.519 -242.335)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41536",
    "data-name": "Path 41536",
    d: "M208.842,272.361a11.113,11.113,0,0,1,1.337.486c1.768-4.254,1.461-3.287,3.271-7.525q1.332-3.119,2.661-6.234c.917-2.162,1.718-4.4,2.752-6.512a.054.054,0,0,1,.1.041c-.544,2.026-1.332,4.005-2.071,5.973.174-.307.336-.623.527-.926.428-.672.847-1.345,1.22-2.046.058-.108.237-.037.178.075-.357.672-.664,1.357-.967,2.055s-.647,1.37-1,2.042c-.34.652-.722,1.274-1.108,1.9-.046.075-.091.154-.141.232-.477,1.233-.938,2.47-1.44,3.694a57.377,57.377,0,0,1-3.736,7.666,11.629,11.629,0,0,1-1.623-.793c-.062-.042-.008-.12.05-.12Z",
    transform: "translate(-187.919 -233.598)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170396",
    "data-name": "Group 170396",
    transform: "translate(41.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41537",
    "data-name": "Path 41537",
    d: "M190.57,109.146a3.9,3.9,0,0,0,5.927-3.86,3.582,3.582,0,0,0,4.35-.548,3.438,3.438,0,0,0,.062-4.562.013.013,0,0,0-.021.012,3.518,3.518,0,0,1-.245,4.342,3.161,3.161,0,0,1-3.437.714,4.311,4.311,0,0,0,3.15-1.374,3.348,3.348,0,0,0,.481-3.669,4.91,4.91,0,0,0,2.835-3.387,3.341,3.341,0,0,0-1.4-3.379,3.736,3.736,0,0,0-1.532-6.691,3.138,3.138,0,0,0-.863-5.209,2.117,2.117,0,0,0,.17-2.275,3.529,3.529,0,0,0-2.183-1.61,2.519,2.519,0,0,0-.946-2.225,2.286,2.286,0,0,0-2.959.212,6.31,6.31,0,0,0-3.553-2.735A3.275,3.275,0,0,0,187,74.114a4.536,4.536,0,0,0-6.782.253,3.185,3.185,0,0,0-3.184.05,4.736,4.736,0,0,0-1.681,1.536,2.391,2.391,0,0,0-2.739.527,3.159,3.159,0,0,0-.751,2.594,1.768,1.768,0,0,1-.515.618,4.153,4.153,0,0,0-1.615,3.574,2.831,2.831,0,0,0-1.469,3.985,3.179,3.179,0,0,0-.523,4.433,4.624,4.624,0,0,0-1.465,3.565,2.684,2.684,0,0,0,1.556,2.507,1.627,1.627,0,0,0,.282,2.146,4.157,4.157,0,0,0,.714.544,3.352,3.352,0,0,1,.955.631,2.564,2.564,0,0,1,.278,1.075,3.753,3.753,0,0,0,.249.726,4.208,4.208,0,0,0,4.769,2.241,3.4,3.4,0,0,0,2.918,2.3,7.208,7.208,0,0,0,1.27.091,1.813,1.813,0,0,1,1.083.257c.208.137.382.324.589.465a2.922,2.922,0,0,0,2.308.237c.975,3.549,5.471,3.507,7.326.7ZM172.552,77.032a2.517,2.517,0,0,1,2.739-.988l-.062.116s-.349.008-.515.029a3.118,3.118,0,0,0-.884.27,3.306,3.306,0,0,0-1.424,1.274,3.412,3.412,0,0,0-.332.793c-.012.037-.025.066-.033.1a3.06,3.06,0,0,1,.515-1.594Zm24.29-.76a2.429,2.429,0,0,0-2.744-.457c-.017-.021-.033-.042-.05-.066A2.151,2.151,0,0,1,196.8,75.6a2.108,2.108,0,0,1,.78,1.963h-.017a2.655,2.655,0,0,0-.726-1.287Zm-13.436,32.143a.34.34,0,0,0,.037-.008,4.379,4.379,0,0,0,5.881,1.606c-2.117,1.37-4.744,1.328-5.919-1.6Z",
    transform: "translate(-166.267 -72.713)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170381",
    "data-name": "Group 170381",
    transform: "translate(28.242 40.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41538",
    "data-name": "Path 41538",
    d: "M234.326,189.164c.336,1.087,6.317,9.684,12.116,8.177,2.436-.635-.008-10.057-.008-10.057l1.536-10.115-13.05-7.069S234.189,188.7,234.326,189.164Z",
    transform: "translate(-234.309 -170.1)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41539",
    "data-name": "Path 41539",
    d: "M248.461,177.164l-1.49,9.82c-1.473-.133-8.052-1.258-11.821-9.891.141-3.785.266-6.994.266-6.994Z",
    transform: "translate(-234.801 -170.1)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170389",
    "data-name": "Group 170389",
    transform: "translate(22.47 15.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41540",
    "data-name": "Path 41540",
    d: "M252.168,127.58c5.114,15.959-3.864,20.828-7.309,21.924-3.125,1-13.892,4-20.629-11.348s-.934-22.771,6.093-25.431,16.731-1.108,21.845,14.851Z",
    transform: "translate(-220.895 -111.065)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170386",
    "data-name": "Group 170386",
    transform: "translate(14.312 12.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41541",
    "data-name": "Path 41541",
    d: "M278.976,139.68a10.728,10.728,0,0,0-1.154.091,1.881,1.881,0,0,0-1.158.315.59.59,0,0,0-.091.722,1.483,1.483,0,0,0,1.4.531,2.186,2.186,0,0,0,1.453-.585.636.636,0,0,0-.444-1.075Z",
    transform: "translate(-267.523 -139.679)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41542",
    "data-name": "Path 41542",
    d: "M255.389,153.316a10.88,10.88,0,0,1,.785-.851,1.86,1.86,0,0,1,.963-.718.6.6,0,0,1,.627.374,1.485,1.485,0,0,1-.444,1.432,2.167,2.167,0,0,1-1.357.78.637.637,0,0,1-.573-1.013Z",
    transform: "translate(-255.109 -146.733)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170383",
    "data-name": "Group 170383",
    transform: "translate(0 8.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170382",
    "data-name": "Group 170382",
    transform: "translate(1.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41543",
    "data-name": "Path 41543",
    d: "M264.118,162.188c-.021-.042-.071.075-.058.12.332,1.092.527,2.4-.369,3.034-.029.021-.008.075.025.058C264.886,164.9,264.608,163.167,264.118,162.188Z",
    transform: "translate(-261.801 -161.287)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41544",
    "data-name": "Path 41544",
    d: "M260.179,160.046c-1.81.345-.988,3.935.689,3.615C262.516,163.35,261.7,159.756,260.179,160.046Z",
    transform: "translate(-259.157 -160.03)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_41545",
    "data-name": "Path 41545",
    d: "M257.017,160.857c-.266.274-.494.706-.863.826-.427.145-.843-.158-1.212-.452-.037-.029-.062.008-.054.054.145.689.573,1.337,1.332,1.27.693-.058,1.038-.78,1.05-1.511,0-.137-.154-.3-.257-.187Z",
    transform: "translate(-254.886 -160.492)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170385",
    "data-name": "Group 170385",
    transform: "translate(10.51 5.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170384",
    "data-name": "Group 170384",
    transform: "translate(0 0.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41546",
    "data-name": "Path 41546",
    d: "M280.21,157.431c0-.046.1.033.108.079.212,1.121.639,2.37,1.731,2.519.033,0,.042.062,0,.062-1.27.1-1.822-1.569-1.843-2.665Z",
    transform: "translate(-280.209 -155.995)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41547",
    "data-name": "Path 41547",
    d: "M280.947,154.044c1.764-.531,2.694,3.034,1.063,3.524C280.4,158.054,279.47,154.488,280.947,154.044Z",
    transform: "translate(-280.207 -153.99)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_41548",
    "data-name": "Path 41548",
    d: "M283.722,153.268c.332.116.7.386,1.042.32.4-.075.585-.535.735-.971.017-.046.05-.021.066.025.2.677.158,1.444-.465,1.747-.564.274-1.158-.2-1.5-.83-.062-.116-.017-.336.116-.286Z",
    transform: "translate(-282.177 -152.592)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_41549",
    "data-name": "Path 41549",
    d: "M265.855,184.943c.315.216.652.527,1.063.49a2.987,2.987,0,0,0,1.154-.5.04.04,0,0,1,.058.05,1.531,1.531,0,0,1-1.316.867,1.22,1.22,0,0,1-1.063-.834c-.029-.062.054-.1.1-.071Z",
    transform: "translate(-261.238 -166.145)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41550",
    "data-name": "Path 41550",
    d: "M269.763,159.114a9.161,9.161,0,0,1,3.848-1.175c.116-.058.369-.232.353-.357v-.008c-.017-.037-.793-2.241-.793-2.241.345.054,2.084.253,1.922-.166a56.96,56.96,0,0,0-4.881-10.468.1.1,0,0,0-.187.087c1.154,3.374,2.889,6.529,4.1,9.9a6.629,6.629,0,0,0-1.868.025c-.1.071.959,2.333,1.038,2.71a5.413,5.413,0,0,0-3.731,1.536C269.137,159.334,269.128,159.48,269.763,159.114Z",
    transform: "translate(-263.295 -142.586)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170387",
    "data-name": "Group 170387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41551",
    "data-name": "Path 41551",
    d: "M238.462,113.4a7.315,7.315,0,0,1,.494,4.242c-1.129,3.914-5.641,3.669-6.894,5.35-1.175,1.573-.228,4.283-1.27,5.836-1.44,2.15-3.939,1.818-4.022,3.121s-.253,5.433-1.764,6.2-13.187-24.605,7.758-27.179c0,0,2.665-1.64,7.463-.125,5.3,1.673,8.754,9.405,8.754,9.405s-.12-.091-.938-.606c-1.15-.726-1.673-1.486-2.507-1.942-1.3-.718-1.884-.27-3.229-.955a13.871,13.871,0,0,1-3.848-3.35Z",
    transform: "translate(-220.404 -110.202)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41552",
    "data-name": "Path 41552",
    d: "M245.891,115.24a14.224,14.224,0,0,1,1.133,3.1,5.962,5.962,0,0,1,.066,3.179,4.385,4.385,0,0,1-2.079,2.258c-.93.527-2,.809-3,1.415a3.276,3.276,0,0,0-1.22,1.283,4.494,4.494,0,0,0-.349,1.706,5.913,5.913,0,0,1-.677,3.084,3.639,3.639,0,0,1-2.594,1.635c-1.05.174-2.254.066-3.2.7,1-.552,2.125-.349,3.233-.444a3.954,3.954,0,0,0,2.893-1.66,5.9,5.9,0,0,0,.818-3.279,4.049,4.049,0,0,1,.32-1.519,2.8,2.8,0,0,1,1.054-1.058c.884-.56,1.972-.872,2.955-1.44a5.629,5.629,0,0,0,1.349-1.058,3.441,3.441,0,0,0,.884-1.494,6.293,6.293,0,0,0-.2-3.366,14.493,14.493,0,0,0-1.382-3.03Z",
    transform: "translate(-228.339 -113.149)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41553",
    "data-name": "Path 41553",
    d: "M264.02,117.38A11.7,11.7,0,0,0,265.5,120.1a5.432,5.432,0,0,0,2.465,1.963,8.118,8.118,0,0,0,1.532.328,2.518,2.518,0,0,1,1.249.573,7.873,7.873,0,0,0,1.108,1.087,3.432,3.432,0,0,0,1.449.556,3.833,3.833,0,0,1-1.291-.76,7.71,7.71,0,0,1-.971-1.158,2.673,2.673,0,0,0-1.444-.78,7.985,7.985,0,0,1-1.449-.332,5.775,5.775,0,0,1-2.32-1.739,23.376,23.376,0,0,1-1.81-2.453Z",
    transform: "translate(-245.917 -114.401)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170388",
    "data-name": "Group 170388",
    transform: "translate(0.501 22.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41554",
    "data-name": "Path 41554",
    d: "M228.882,167.948s-4.728-4.292-6.753-2.49,2.337,8.584,5.284,8.978a2.836,2.836,0,0,0,3.366-2.329Z",
    transform: "translate(-221.611 -165.016)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41555",
    "data-name": "Path 41555",
    d: "M225.956,170.651c-.046,0-.037.071,0,.075,2.079.34,3.487,1.876,4.6,3.549a1.563,1.563,0,0,0-2.378.1c-.042.046.025.112.075.091a1.746,1.746,0,0,1,2,.166,8.456,8.456,0,0,1,1.241,1.312c.129.149.415-.012.307-.191-.008-.012-.017-.029-.025-.041-.506-2.441-3.167-5.408-5.832-5.064Z",
    transform: "translate(-224.134 -168.296)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170395",
    "data-name": "Group 170395",
    transform: "translate(18.294 7.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170391",
    "data-name": "Group 170391",
    transform: "translate(0 5.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41556",
    "data-name": "Path 41556",
    d: "M219.468,137.936c.2.731-2.528-1.27-2.723-1.619s-1.905-1.1-2.449-1.743a19.05,19.05,0,0,1-1.947-3.1c-.174-.5-1.407-1.569-1.606-2.474s-1.648-9.048,2.549-15.669,8.928-8.048,8.928-8.048a34.512,34.512,0,0,1,7.239-1.955c4.014-.61,11.767,7.38,11.829,7.579a3.463,3.463,0,0,0,.245,1.4c.311.515,1.042.959.855,1.556s.913,1.8,1.029,2.37,0,.751.187,1.121-3.906-9.26-16.781-10.045c0,0-11.568,14.922-7.355,30.628Z",
    transform: "translate(-210.342 -103.29)",
    fill: "#01abc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41557",
    "data-name": "Path 41557",
    d: "M290.38,136.92a.441.441,0,0,0,.046.1C290.442,137.053,290.426,137.015,290.38,136.92Z",
    transform: "translate(-257.159 -122.961)",
    fill: "#01abc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41558",
    "data-name": "Path 41558",
    d: "M290.38,136.92a.378.378,0,0,0,.046.1C290.442,137.053,290.426,137.015,290.38,136.92Z",
    transform: "translate(-257.159 -122.961)",
    fill: "#01abc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41559",
    "data-name": "Path 41559",
    d: "M236.189,106.868a1.089,1.089,0,0,1,.415-.125h0c.39.307.772.614,1.133.917h0a1.053,1.053,0,1,1-1.548-.793Zm-5.832,1.092c.71.145,1.386.32,2.034.519a1.033,1.033,0,0,0-.075-.847,1.051,1.051,0,0,0-1.432-.415,1.064,1.064,0,0,0-.531.743Zm8.11,3.561a19.058,19.058,0,0,1,1.569,1.3,1.055,1.055,0,0,0-1.125-1.781A1.037,1.037,0,0,0,238.468,111.52Zm-23.223-.589a1.053,1.053,0,1,0,1.382-1.548c-.452.465-.921.975-1.386,1.548Zm2.15,8.638a1.055,1.055,0,1,0,.419-1.432A1.057,1.057,0,0,0,217.4,119.569Zm9.634-14.917a1.053,1.053,0,1,0,1.847-1.013v-.008c-.689.12-1.349.261-1.967.407h0a1.023,1.023,0,0,0,.125.61Zm-5.039,3.578a1.055,1.055,0,1,0,.419-1.432A1.057,1.057,0,0,0,221.99,108.229Zm-1.822,5.616a1.055,1.055,0,1,0,.419-1.432A1.057,1.057,0,0,0,220.168,113.845Zm-7.442,2.876a1.055,1.055,0,1,0,.419-1.432A1.057,1.057,0,0,0,212.726,116.721Zm1.685,7.836a1.055,1.055,0,1,0,.419-1.432A1.057,1.057,0,0,0,214.411,124.558Zm3.424,11.4a1.052,1.052,0,0,0,1.316.469c-.137-.677-.249-1.353-.328-2.03a1.048,1.048,0,0,0-.988,1.557Zm.6-8.812a1,1,0,0,0,.378.39c.071-.643.162-1.283.27-1.913a.973.973,0,0,0-.228.091,1.047,1.047,0,0,0-.415,1.428Zm-7.957-4.176a1.05,1.05,0,0,0,1.253-1.5,1.064,1.064,0,0,0-1.034-.544C210.6,121.627,210.522,122.316,210.48,122.968Zm3.951,7.795a1.055,1.055,0,1,0,.419-1.432A1.057,1.057,0,0,0,214.431,130.763Zm-1.5,1.851c.266.444.594.963.888,1.4a1.045,1.045,0,0,0-.888-1.395ZM210.75,128.8a1.031,1.031,0,0,0,.544-.129,1.054,1.054,0,0,0-.793-1.938c.071.917.174,1.631.253,2.067Z",
    transform: "translate(-210.423 -103.489)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170390",
    "data-name": "Group 170390",
    transform: "translate(1.568 2.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41560",
    "data-name": "Path 41560",
    d: "M223.329,158.345a11.057,11.057,0,0,1-.531-2.171c-.133-.735-.245-1.473-.349-2.212-.2-1.478-.4-2.964-.527-4.449-.033-.369-.071-.743-.079-1.108a4.852,4.852,0,0,1,.178-1.071c.183-.718.419-1.428.639-2.142s.469-1.419.718-2.125l.739-2.117q-.89,2.061-1.648,4.176c-.253.706-.486,1.42-.681,2.146a5.059,5.059,0,0,0-.2,1.133c0,.386.037.755.066,1.129q.224,2.241.589,4.454c.129.739.257,1.473.419,2.208.083.365.17.731.27,1.092a5.257,5.257,0,0,0,.386,1.054Z",
    transform: "translate(-218.489 -128.241)",
    fill: "#050400",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41561",
    "data-name": "Path 41561",
    d: "M216.3,146.3a18.134,18.134,0,0,0-1.1,2.441,17.953,17.953,0,0,0-.764,2.573,12.852,12.852,0,0,0-.315,2.673,7.308,7.308,0,0,0,.444,2.64c-.042-.22-.087-.436-.137-.652a1.733,1.733,0,0,1-.046-.328l-.029-.332c-.008-.108-.025-.22-.033-.328v-.332a5,5,0,0,1,.008-.66l.046-.66.087-.656c.025-.22.066-.436.108-.652s.075-.436.129-.652a26.323,26.323,0,0,1,.7-2.565q.2-.635.436-1.258c.145-.419.311-.834.477-1.249Z",
    transform: "translate(-214.119 -131.37)",
    fill: "#050400",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41562",
    "data-name": "Path 41562",
    d: "M273.189,116a13.651,13.651,0,0,0-1.847-1.752c-.652-.544-1.324-1.063-2-1.573a24.781,24.781,0,0,0-2.1-1.444,8.607,8.607,0,0,0-2.387-.9,12,12,0,0,1,1.175.477,9.155,9.155,0,0,1,1.108.594c.353.224.689.477,1.029.726l1.021.755,2.034,1.519c.34.253.672.511,1,.772A10.117,10.117,0,0,1,273.189,116Z",
    transform: "translate(-243.793 -110.33)",
    fill: "#050400",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41563",
    "data-name": "Path 41563",
    d: "M279.74,123.09a13.157,13.157,0,0,0-1.17-1.415,17.448,17.448,0,0,0-1.312-1.287,7.479,7.479,0,0,0-.731-.569c-.257-.162-.515-.332-.776-.49l-.785-.477c-.266-.149-.527-.311-.8-.452.237.2.486.374.726.56l.739.535c.245.183.5.349.747.523a8.172,8.172,0,0,1,.7.564c.457.394.9.814,1.341,1.229.22.208.44.419.66.631s.436.423.652.643Z",
    transform: "translate(-249.245 -115.05)",
    fill: "#050400",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_41564",
    "data-name": "Path 41564",
    d: "M219.594,112.015c2.221.419,7.3,1.316,8.339,1a7.434,7.434,0,0,0,1.017-.444,40.333,40.333,0,0,1,3.283-5.259,24.123,24.123,0,0,1,4.433.677,22.579,22.579,0,0,0,2.636-3.262,7.423,7.423,0,0,0-4.433-1.4,34.418,34.418,0,0,0-7.239,1.955s-4.088,1.233-8.04,6.737Z",
    transform: "translate(-215.751 -103.29)",
    fill: "#050400",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170394",
    "data-name": "Group 170394",
    transform: "translate(1.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170392",
    "data-name": "Group 170392",
    transform: "translate(13.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41565",
    "data-name": "Path 41565",
    d: "M247.15,97.543s2.939-6.135,8.716-7.413c0,0,.382,5.819-1.469,7.949-.921,1.058-5.458,1.938-6.077,1.237a10.623,10.623,0,0,1-1.17-1.768Z",
    transform: "translate(-247.146 -90.13)",
    fill: "#01abc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41566",
    "data-name": "Path 41566",
    d: "M254.4,93.23a1.051,1.051,0,0,1-1.586,1.146,11.929,11.929,0,0,1,1.59-1.141Zm1.913,4.3a1.056,1.056,0,0,0,.706.523,12.438,12.438,0,0,0,.415-2.063,1.021,1.021,0,0,0-.7.112,1.055,1.055,0,0,0-.415,1.432Zm-6.131,1.034a1.055,1.055,0,1,0,.419-1.432A1.057,1.057,0,0,0,250.178,98.568Z",
    transform: "translate(-248.842 -91.943)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41567",
    "data-name": "Path 41567",
    d: "M247.144,105.11a10.982,10.982,0,0,0,1.166,1.76.247.247,0,0,0,.1.079.406.406,0,0,0,.141.071c.037,0,.071.025.12.033a6.387,6.387,0,0,0,2.544-.137,13.717,13.717,0,0,0-.9-2.449,3.841,3.841,0,0,0-1.913-1.407,13.931,13.931,0,0,0-1.266,2.05Z",
    transform: "translate(-247.14 -97.693)",
    fill: "#050400",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170393",
    "data-name": "Group 170393",
    transform: "translate(0 8.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41568",
    "data-name": "Path 41568",
    d: "M227,110.231s-8.272-.394-12,1.785c0,0,2.582,4.018,6.77,4.636,1.876.278,6.869-3.607,6.479-4.533A8.257,8.257,0,0,0,227,110.235Z",
    transform: "translate(-215 -110.199)",
    fill: "#01abc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41569",
    "data-name": "Path 41569",
    d: "M221.968,113.631a1.055,1.055,0,1,1-.419,1.432A1.058,1.058,0,0,1,221.968,113.631Zm6.429-1.121a1.055,1.055,0,1,0,.419-1.432A1.057,1.057,0,0,0,228.4,112.51Zm-1.656,4.379a7.546,7.546,0,0,0,.764-.32,1.026,1.026,0,0,0-.511.129A1.068,1.068,0,0,0,226.741,116.889Z",
    transform: "translate(-218.755 -110.636)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41570",
    "data-name": "Path 41570",
    d: "M239.35,110.2a4.752,4.752,0,0,0,.432,2.677,4.091,4.091,0,0,0,1.212,1.224c.975-.834,1.627-1.627,1.482-1.992a8.325,8.325,0,0,0-1.245-1.884s-.739-.037-1.876-.025Z",
    transform: "translate(-229.227 -110.194)",
    fill: "#050400",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_41571",
    "data-name": "Path 41571",
    d: "M241.7,109.046a2.69,2.69,0,1,0,.76-3.727A2.686,2.686,0,0,0,241.7,109.046Z",
    transform: "translate(-230.355 -98.752)",
    fill: "#01abc1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170400",
    "data-name": "Group 170400",
    transform: "translate(0 50.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41572",
    "data-name": "Path 41572",
    d: "M137.879,284.49c3-5.425,5.143-17.624-1.224-41.361-.88-3.283-24.979,1.337-24.219,4.889.959,4.479,5.645,21.654,6.143,22.866,4.23,10.227,17.263,17.283,19.3,13.6Z",
    transform: "translate(-92.841 -222.3)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41573",
    "data-name": "Path 41573",
    d: "M178.449,302.358a26.71,26.71,0,0,0,1.337-5.454c.129-.93.237-1.864.295-2.8a23,23,0,0,0-.008-2.831,55.668,55.668,0,0,0-.581-5.583,42.52,42.52,0,0,0-1.17-5.483c.291,1.843.494,3.694.677,5.545s.328,3.7.411,5.554c.033.926.062,1.847.012,2.76s-.116,1.847-.208,2.768C179.034,298.68,178.81,300.523,178.449,302.358Z",
    transform: "translate(-131.389 -244.647)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170399",
    "data-name": "Group 170399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170397",
    "data-name": "Group 170397",
    transform: "translate(0 1.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41574",
    "data-name": "Path 41574",
    d: "M97.249,227.691c-2.773-.071-17.69-1.212-21.177-2.254-5.969-1.785-11.107-4.308-10.157-6.944.872-2.424,7.509-.162,7.509-.162s-9.2-5.412-8.077-9.048c.834-2.706,4.931-.216,4.931-.216s-4.263-3.507-2.461-5.691c1.494-1.81,10.273,3.736,10.273,3.736s-8.243-6.243-5.014-8.555c2.121-1.519,6.018,3.3,10.92,4.686.432.12,4.669.988,8.874,1.835,4.375.884,16.358,13.07,16.358,13.07l-11.983,9.542Z",
    transform: "translate(-65.252 -198.265)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41575",
    "data-name": "Path 41575",
    d: "M96.233,219.463a26.815,26.815,0,0,0,7.006,2.686c.058.017.042.178-.025.17-3.458-.4-4.454-.755-7.1-2.71C95.972,219.5,96.092,219.385,96.233,219.463Z",
    transform: "translate(-83.267 -210.65)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41576",
    "data-name": "Path 41576",
    d: "M77.5,224.162c4.927,3.458,7.716,4.416,13.556,5.653.083.017.062.158-.025.149-5.832-.735-9.2-1.424-13.668-5.525-.2-.187-.091-.436.137-.274Z",
    transform: "translate(-72.272 -213.385)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41577",
    "data-name": "Path 41577",
    d: "M84.933,246.347a67.342,67.342,0,0,0,7.741,1.772c.091.017.1.216,0,.212-3.561-.17-4.856-.295-7.787-1.81-.224-.116-.191-.241.046-.17Z",
    transform: "translate(-76.649 -226.38)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170398",
    "data-name": "Group 170398",
    transform: "translate(19.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41578",
    "data-name": "Path 41578",
    d: "M137.23,215.964s-2.727-11.419-7.807-15.461c-2.549-2.026-14.536-7.8-15.959-5.4-1.839,3.109,4.113,7.841,7.33,9.779,0,0-4.259,7.185-.722,11.506S137.23,215.964,137.23,215.964Z",
    transform: "translate(-113.118 -194.53)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41579",
    "data-name": "Path 41579",
    d: "M113.323,198.347c.369,4.043,4.757,6.313,7.737,8.43a.332.332,0,0,1,.021.548c-1.586,3.13-2.91,8.007-1.154,11.269a.084.084,0,0,1-.141.091c-2.358-3.242-1.449-8.139.506-11.456-3.092-2.121-7.392-4.591-7.006-8.878a.019.019,0,1,1,.037,0Z",
    transform: "translate(-113.202 -196.754)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170404",
    "data-name": "Group 170404",
    transform: "translate(104.166 50.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41580",
    "data-name": "Path 41580",
    d: "M321,284.29c-3-5.425-5.143-17.624,1.225-41.361.88-3.283,24.979,1.337,24.219,4.889-.959,4.479-5.645,21.654-6.143,22.866-4.23,10.227-17.263,17.283-19.3,13.6Z",
    transform: "translate(-317.312 -222.1)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41581",
    "data-name": "Path 41581",
    d: "M317.884,302.158a26.708,26.708,0,0,1-1.337-5.454c-.129-.93-.237-1.864-.295-2.8a23.011,23.011,0,0,1,.008-2.831,55.674,55.674,0,0,1,.581-5.583,42.521,42.521,0,0,1,1.17-5.483c-.291,1.843-.494,3.694-.677,5.545s-.328,3.7-.411,5.554c-.033.926-.062,1.847-.012,2.76s.116,1.847.208,2.768C317.3,298.48,317.523,300.323,317.884,302.158Z",
    transform: "translate(-316.213 -244.447)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_170403",
    "data-name": "Group 170403",
    transform: "translate(4.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170401",
    "data-name": "Group 170401",
    transform: "translate(0.004 1.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41582",
    "data-name": "Path 41582",
    d: "M339.639,227.491c2.773-.071,17.69-1.212,21.177-2.254,5.969-1.785,11.107-4.308,10.157-6.944-.872-2.424-7.509-.162-7.509-.162s9.2-5.412,8.077-9.048c-.834-2.706-4.931-.216-4.931-.216s4.263-3.507,2.461-5.691c-1.494-1.81-10.273,3.736-10.273,3.736s8.243-6.243,5.014-8.555c-2.121-1.519-6.018,3.3-10.92,4.686-.432.12-4.67.988-8.874,1.835-4.375.884-16.358,13.07-16.358,13.07l11.983,9.542Z",
    transform: "translate(-327.66 -198.065)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41583",
    "data-name": "Path 41583",
    d: "M392.446,219.263a26.815,26.815,0,0,1-7.006,2.685c-.058.017-.041.178.025.17,3.458-.4,4.454-.755,7.1-2.71C392.708,219.3,392.587,219.185,392.446,219.263Z",
    transform: "translate(-361.437 -210.45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41584",
    "data-name": "Path 41584",
    d: "M401.842,223.952c-4.927,3.457-7.716,4.416-13.556,5.653-.083.017-.062.158.025.149,5.832-.735,9.2-1.424,13.668-5.525.2-.187.091-.436-.137-.274Z",
    transform: "translate(-363.091 -213.179)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41585",
    "data-name": "Path 41585",
    d: "M402.642,246.147a67.339,67.339,0,0,1-7.741,1.772c-.091.017-.1.216,0,.212,3.561-.17,4.856-.295,7.787-1.81.224-.116.191-.241-.046-.17Z",
    transform: "translate(-366.951 -226.18)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170402",
    "data-name": "Group 170402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41586",
    "data-name": "Path 41586",
    d: "M327.65,215.764s2.727-11.418,7.807-15.461c2.549-2.026,14.536-7.8,15.959-5.4,1.839,3.109-4.113,7.841-7.33,9.779,0,0,4.259,7.185.722,11.506S327.65,215.764,327.65,215.764Z",
    transform: "translate(-327.65 -194.33)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41587",
    "data-name": "Path 41587",
    d: "M374.338,198.147c-.369,4.043-4.757,6.313-7.737,8.43a.332.332,0,0,0-.021.548c1.586,3.13,2.91,8.007,1.154,11.269a.084.084,0,0,0,.141.091c2.358-3.242,1.449-8.139-.506-11.456,3.092-2.121,7.392-4.591,7.006-8.878a.019.019,0,1,0-.037,0Z",
    transform: "translate(-350.343 -196.553)",
    fill: "#263238"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-1",
    transform: "translate(12.455 176.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41588",
    "data-name": "Path 41588",
    d: "M53.32,461.758c40.773-.2,86.513-.2,127.286,0-40.773.2-86.513.2-127.286,0h0Z",
    transform: "translate(-53.32 -461.609)",
    fill: "#263238"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Symbol--inject-1",
    transform: "translate(96.578 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41589",
    "data-name": "Path 41589",
    d: "M298.581,61.3l-.672,3.947a2.946,2.946,0,0,1-3.482,2.47,3.027,3.027,0,0,1-2.47-3.482l1.075-6.313c.008-.062.071-.05.083-.112a.188.188,0,0,1-.042-.133,3.112,3.112,0,0,1,3.482-2.47,6.9,6.9,0,1,0,2.32-13.6,6.807,6.807,0,0,0-6.4,2.345,3.044,3.044,0,0,1-4.317.39,3.005,3.005,0,0,1-.34-4.246,12.945,12.945,0,1,1,10.759,21.2ZM296.315,74.6l-.187,1.092a2.949,2.949,0,0,1-3.482,2.47,3.024,3.024,0,0,1-2.47-3.482l.187-1.092a3.067,3.067,0,0,1,3.482-2.47,2.985,2.985,0,0,1,2.47,3.482Z",
    transform: "translate(-287.101 -35.476)",
    fill: "#455a64"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMasterTounament);
export default __webpack_public_path__ + "static/media/no-master-tounament.e79f31e760dbc146a30c79884641bde7.svg";
export { ForwardRef as ReactComponent };